import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Explore from "../Explore/Explore";
import MyAccount from "../MyAccount/MyAccount";
import OrdersTable from "../Orders Details/OrderList/OrdersTable";
import OrderView from "../Orders Details/Orderview/OrderView";
import ChangePassword from "../Change Password/ChangePassword";
import Test from "../Test";
import ContactUs from "../Contact Us/ContactUs";
import Faq from "../Faq/Faq";
import CampaignList from "../CampaignList/CampaignList";
import SubPages from "../SubPages/SubPages";
import BlogsList from "../Blogs/BlogsList";
import BlogDetail from "../Blogs/BlogsDetail/BlogDetail";
import Error404 from "../../components/Error404/Error404";
import Profile from "../MyAccount/Profile";
import EmailOrderPage from "../EmailOrderPage/EmailOrderPage";
// import AllPages from "../AllPages/AllPages"
import Layout from "../../components/Layout/Layout"
import Otp from "../Auth/OtpPage/Otp"
import ForgotPassword from "../Auth/ForgetPasswordPage/ForgotPassword"
import Checkout from "../checkout/Checkout"
import LazyLoading from "../../components/LazyLoading/LazyLoading";



// const Layout = lazy(() => import("../../components/Layout/Layout"));
// const Home = lazy(() => import("../../pages/Home/Home"));
// const Shop = lazy(() => import("../../pages/shop/Shop"));
// const Auth = lazy(() =>
//   import("../Auth/AuthenticationPage/AuthenticationPage")
// );
// const Otp = lazy(() => import("../Auth/OtpPage/Otp"));
// const ForgotPassword = lazy(() =>
//   import("../Auth/ForgetPasswordPage/ForgotPassword")
// );
// const Cart = lazy(() => import("../cart/Cart"));
// const Wishlist = lazy(() => import("../wishlist/Wishlist"));
// const Checkout = lazy(() => import("../checkout/Checkout"));
// const AddressDetails = lazy(() => import("../AddressDetails/AddressDetails"));
const AllPages = lazy(() => import("../AllPages/AllPages"));

// const ViewProduct = lazy(() => import("../../pages/ViewProduct/ViewProduct"));
const isAuthenticated = () => {
  return !!localStorage.getItem("token");
};

const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

const routes = [
  {
    path: "",
    element: <Layout />,
    auth: true,
    children: [
      {
        path: "/*",
        element: <AllPages />,
      },
      {
        path: "/",
        element: <AllPages />,
      },
      {
        path: "*",
        element: <Error404 />,
      },
      {
        path: "/otp-verfiy",
        element: <Otp />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "/policy/:page_name",
        element: <SubPages />,
      },
      {
        path: "/checkout",
        element: (
          <ProtectedRoute>
            <Checkout />
          </ProtectedRoute>
        ),
      },

      // {
      //   path: "/change-password",
      //   element: (
      //       <ChangePassword />
      //   ),
      // },
      // {
      //   path: "/order-list",
      //   element: (
      //       <OrdersTable />
      //   ),
      // },
      // {
      //   path: "/view",
      //   element: (
      //       <OrderView />
      //   ),
      // },
      {
        path: "/:slug",
        element: <AllPages />,
      },
      {
        path: "/order-view",
        element: <EmailOrderPage />,
      },
    ],
  },
  //   { path: "/checkout", element: <ProtectedRoute element={<Checkout />} /> },
];

// Component for all the Routes
const AllRoutes = () => {
  return (
    <Suspense fallback={<LazyLoading/>}>
      <Routes>
        {routes.map((route, index) => {
          if (route.children) {
            return (
              <Route key={index} path={route.path} element={route.element}>
                {route.children.map((childRoute, childIndex) => (
                  <Route
                    key={childIndex}
                    path={childRoute.path}
                    element={childRoute.element}
                  />
                ))}
              </Route>
            );
          } else {
            return (
              <Route key={index} path={route.path} element={route.element} />
            );
          }
        })}
      </Routes>
     </Suspense>
  );
};

export default AllRoutes;
